
export default {
  list: [],
  isUnique: true
}



// WEBPACK FOOTER //
// ./src/features/admin/comprarCursos/store/state.js